const elements =
  'variantOption(code,variantOptionQualifiers(image(url,format))),variantValueCategory(name),parentVariantCategory(hasImage,name)';
const variantMatrix = `variantMatrix(${elements},elements(${elements},elements(${elements},elements)))`;
export const defaultOccProductMultiDimensionalSelectorConfig = {
  backend: {
    occ: {
      endpoints: {
        product: {
          multi_dimensional:
            'gonvarri/products/${productCode}?fields=multidimensional,categories,price,' +
            variantMatrix,
          multi_dimensional_availability:
          'gonvarri/products/${productCode}?fields=DEFAULT',

        },
      },
    },
  },
};
